module.exports = __webpack_public_path__ + "img/librarybg2.20d534dc.png";